<script>

    import { toast } from 'bulma-toast'
    import { userStore, chargesStore, modalStore } from '../stores'

    import ChargesService from '../$services/charges.service'

    import Subtitle from '../$components/subtitle.svelte'
    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'

    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    export let label = false
    export let shipmentId = null
    export let userId = null

    let data = {
        shipmentId,
        userId
    }

    let loading = false

    async function createCharge() {

        data.userId = userId || $userStore._id
        data.shipmentId = shipmentId

        loading = true
        const resp = await ChargesService.createCharge(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.append(resp.data)

        toast({message: 'Cargo creado', type: 'is-success'})
        
        modalStore.close()
    }

</script>

{#if label}
    <Subtitle text="Crear cargo" />
{/if}

<Form on:submit={ createCharge } { loading } >

    <Select bind:value={ data.type } 
        label="Tipo"
        options={[
            {value: 'charge', text: 'Cargo'},
            {value: 'refund', text: 'Reembolso'},
        ]}
    />

    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.concept } label="Concepto" placeholder="Concepto" />
        </div>
        <div class="column">
            <InputNumber bind:value={ data.amount } label="Monto" placeholder="Monto" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.details } label="Detalles" placeholder="Detalles" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="plus" text="Crear" { loading } />
    </div>

</Form>